// extracted by mini-css-extract-plugin
export default {"container":"adminInfoBlok_container__1kkYG","top":"adminInfoBlok_top__X9iwK","btn":"adminInfoBlok_btn__nH2uk","postContainer":"adminInfoBlok_postContainer__nwWQS"};